import { useContext } from 'react';
import { TemplateDataContext } from '.';
export const useComposerData = () => {
    const context = useContext(TemplateDataContext);
    if (!context) {
        throw new Error('useComposerData must be used as a child to <ComposerDataProvider>');
    }
    return context;
};
